module.exports = __webpack_public_path__ + "static/img/bg_right.b4054490.png";